// Un import en euros tal com es mostra: coma decimal, punt de milers i sense
// zeros finals (11 → "11", 11.5 → "11,5", 11.95 → "11,95", 1234.5 → "1.234,5").
// Amb { cents: true }, si té cèntims en mostra sempre dos (0.7 → "0,70"), menys
// el mig euro, que queda "0,5": per als desglossaments on els imports se sumen
// (9,99 + 0,70 = 10,69).
// Amb { fixed: true }, sempre dos decimals, també als imports rodons (5 → "5,00"):
// per a les pantalles on tots els imports van en columna.
// Accepta números i textos ("11.9" o "11,9"); el que no és un número surt "0".
// El símbol el posa qui el mostra: `${formatMoney(preu)}€`.
export const formatMoney = (value, { cents: twoDecimalCents = false, fixed = false } = {}) => {
    const amount = typeof value === 'string' ? Number(value.trim().replace(',', '.')) : Number(value);
    if (!Number.isFinite(amount)) return '0';

    const cents = Math.round((Math.abs(amount) + Number.EPSILON) * 100);
    const units = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const twoDecimals = cents % 100 === 0 && !fixed ? '' : String(cents % 100).padStart(2, '0');
    const decimals = fixed || (twoDecimalCents && twoDecimals !== '50') ? twoDecimals : twoDecimals.replace(/0+$/, '');
    return `${amount < 0 && cents > 0 ? '-' : ''}${units}${decimals ? `,${decimals}` : ''}`;
};
